import { useEffect, useRef, useState } from "react";

import { Input } from "@/components/ui/input";
import { confColor } from "@/lib/miscellaneous/confidence-color";
import { cleanVatPreSave, cn } from "@/lib/utils";

export const VatField = ({
  value,
  confidence,
  onChange,
  readOnly = false,
  disabled = false,
}: {
  value: number | null;
  confidence: number | null;
  onChange: (value: any) => void;
  readOnly?: boolean | string | React.ReactNode;
  disabled?: boolean | string | React.ReactNode;
}): any => {
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const inputRef = useRef<any>(null);

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      className={cn(
        "flex items-center justify-end m-1 rounded h-10",
        confColor(confidence),
      )}
      onClick={() => inputRef.current?.focus()}
    >
      <Input
        type="text"
        className={cn(
          "text-right font-normal text-sm bg-transparent pr-1",
          confColor(confidence),
        )}
        style={{
          border: "none",
          outline: "none",
          textAlign: "right",
        }}
        readOnly={readOnly}
        disabled={disabled}
        placeholder=""
        ref={inputRef}
        defaultValue={currentValue?.toString() ?? ""}
        value={currentValue?.toString() ?? ""}
        onChange={(e) => {
          const val = e.target.value.replace(/[a-zA-Z]/g, "");
          const newValue = cleanVatPreSave(val);
          setCurrentValue(newValue);
        }}
        onBlur={() => onChange(currentValue)}
      />
      <span className={cn("p-1 text-right block", confColor(confidence))}>
        %
      </span>
    </div>
  );
};
